import { useAuth } from '../contexts/AuthContext';

export function RejectedPage() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            />
          </svg>
        </div>

        <h1 className="text-xl font-bold mb-2">帳號已被拒絕</h1>

        <p className="text-gray-600 mb-4">
          您的帳號 <span className="font-medium">{user?.email}</span>{' '}
          已被管理員拒絕存取。
          <br />
          如有疑問，請聯繫管理員。
        </p>

        <button
          onClick={logout}
          className="text-gray-500 hover:text-gray-700 text-sm"
        >
          登出
        </button>
      </div>
    </div>
  );
}
